export default __webpack_public_path__ + "e93927bb3d27208b88bb90493a27b3b1.svg";